import { render, staticRenderFns } from "./TablaPreguntas.vue?vue&type=template&id=753f95d4"
import script from "./TablaPreguntas.vue?vue&type=script&lang=js"
export * from "./TablaPreguntas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports